// extracted by mini-css-extract-plugin
module.exports = {"chart":"ChartSelector_chart__3hfRy","funnel":"ChartSelector_funnel__2mH1B"};